<template>
    <span
        v-html="$t('notification.reservationDeletedPlan', {name:$_.get(activity, 'actorUser.name'),title:$_.get(activity, 'payload.title')})"></span>
</template>
<script>
export default {
    name: "ReservationDeleted",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
<style></style>
